import { ForumFeed } from "./forum/forum-feed";
import type { loadForumPage } from "./forum/forum.data";

type ForumData = Awaited<ReturnType<typeof loadForumPage>>;

export function ForumPage({ data }: { readonly data: ForumData }) {
  return (
    <ForumFeed
      key={data.room.forumSlug}
      {...data.room}
      initialPage={data.page}
      lede={data.room.game ? undefined : data.metadata.description}
    />
  );
}
